<template>
    <div class="form-element__container" :id="fullFormIdentifier + '-container'">
        <input
            :id="fullFormIdentifier"
            v-model="lastName"
            :class="{ 'form-element__input--active': lastName !== '' }"
            class="form-element__input"
            type="text"
            data-validate="input"
            data-validate-message="Please enter your last name"
            :data-error-target="fullFormIdentifier + '-container'"
            name="last-name"
            autocomplete="off"
            placeholder="Last Name *"
            :readonly="readonly"
        />
    </div>
</template>

<script>
    export default {
        props: {
            formIdentifier: {
                type: String,
                default: "form",
            },
            readonly:{
                type: Boolean,
                default: false
            }
        },
        computed: {
            lastName: {
                get: function () {
                    return this.$store.state.CustomerData.lastName;
                },
                set: function (newValue) {
                    this.$store.dispatch("CustomerData/storeCustomerData", { lastName: newValue });
                },
            },
            fullFormIdentifier() {
                return this.formIdentifier + "-" + this._uid;
            },
        },
    };
</script>